const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/arbeitgeber.ts';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';

export const REQUEST_ACTION_TYPES_LOAD_ARBEITGEBER_RECORDS = kisapiActionTypes('PATAPP_LOAD_ARBEITGEBER_RECORDS');

export function loadArbeitgeberRecords(patnr: string) {
    const endpoint = 'employers';
    const meta = { suppressErrorMsg: true, patnr };
    return createPatapiCall(REQUEST_ACTION_TYPES_LOAD_ARBEITGEBER_RECORDS, endpoint, HttpMethod.GET, meta);
}
